import type { Profile } from "@/hooks/useAuth";
import { statoAccesso } from "@/lib/statoAccesso";

/**
 * ⏸️ IL BANCO E' IN STANDBY (Davide, 08/09/2026, prima del lancio).
 *
 * «Tutto il codice che riguarda il banco per l'assistenza umana deve essere
 * messo in standby.» Il motivo non e' che funziona male: e' che la v1 parte
 * con l'assistente, e l'assistenza umana entra in scena solo quando avra' una
 * regola sua — quella scritta nella ROTTA del primo aggiornamento: dopo tre o
 * quattro risposte che non risolvono, l'installatore puo' passare alle persone
 * di Datacom, che rispondono dal lunedi' al venerdi' (orari in orarioBanco.ts).
 *
 * COSA VUOL DIRE «STANDBY», QUI. Il codice resta tutto dov'e' — pagine, chat,
 * pannello, tabelle, policy: non si cancella niente, perche' quello che si
 * cancella si riscrive. Si spegne la PORTA, in un punto solo: questa funzione.
 * Con l'interruttore a `true` nessuno vede il banco: ne' l'installatore a cui
 * era stato concesso, ne' l'operatore Datacom, ne' l'admin. Le voci di menu'
 * spariscono, le due pagine rimandano indietro, la scheda del pannello non si
 * apre.
 *
 * COME SI RIACCENDE: si mette `BANCO_IN_STANDBY = false` e si ripubblica.
 * Nient'altro. Prima di farlo, due cose da sistemare (annotate nella rotta):
 * il passaggio automatico dopo N risposte insufficienti, e la prova sul
 * telefono della schermata del banco (il difetto della tacca dell'iPhone,
 * corretto l'08/09 ma mai visto su un dispositivo vero).
 *
 * 🔛 RIACCESO PROVVISORIAMENTE (Davide, 23/09/2026). La porta e' aperta, ma
 * resta una CONCESSIONE per cliente (`bancoConcesso`): nessun installatore lo
 * vede finche' Datacom non glielo accende dal pannello, e chi lo vede scrive
 * solo con l'account attivo. Le due cose da sistemare qui sopra restano da
 * fare. Per rispegnerlo: `true` e ripubblica.
 */
export const BANCO_IN_STANDBY = false;

/**
 * Chi vede (e usa) la chat col banco Datacom.
 *
 * E' una CONCESSIONE, come i marchi (Davide, 01/09): spenta per tutti,
 * la accende Datacom dal pannello sul singolo cliente. La voce di menu',
 * la scheda negli strumenti e la pagina usano tutti QUESTA regola; il
 * database ne fa rispettare una copia nella policy di scrittura, cosi'
 * nessuno scrive al banco chiamando l'API a mano.
 */
export function bancoConcesso(
  profile: Profile | null,
  isAdmin: boolean,
  /** Ha una richiesta di tecnico aperta (l'ultimo salvagente): la porta e' aperta per quel caso. */
  richiestaAperta = false,
): boolean {
  if (BANCO_IN_STANDBY) return false;
  if (isAdmin || profile?.banco_operatore) return true;
  if (richiestaAperta) return true;
  return profile?.banco_abilitato === true && statoAccesso(profile) === "abbonato";
}

/**
 * Chi RISPONDE al banco. Davide, 24/09/2026: «al banco tutti gli account
 * @datacomtecnologie possono rispondere» — non serve promuovere nessuno.
 * Stessa regola di `utenteInterno` nella funzione chat e di
 * `e_operatore_banco()` nel database (migrazione del 24/09).
 */
export const DOMINI_INTERNI = ["@datacomtecnologie.it", "@b2brand.it"];

export function utenteInterno(email: string | null | undefined): boolean {
  const e = (email ?? "").toLowerCase();
  return !!e && DOMINI_INTERNI.some((d) => e.endsWith(d));
}

export function eOperatoreBanco(profile: Profile | null, isAdmin: boolean, email: string | null | undefined): boolean {
  if (BANCO_IN_STANDBY) return false;
  return isAdmin || profile?.banco_operatore === true || utenteInterno(email);
}

/**
 * Il banco e' governabile dal pannello admin? In standby no: una scheda che
 * concede un privilegio che poi non esiste e' peggio di una scheda assente.
 */
export function bancoGovernabile(): boolean {
  return !BANCO_IN_STANDBY;
}
